import React from 'react'
import { LinkProps, Link as ReactRouterLink } from 'react-router-dom'
import styled from '../../utils/styled'
import { getSalonGuidFromUrlParams } from '../../utils/urlParams'

type LinkContainerProps = {
  alternateLinkColor?: boolean
  horizontalMargin?: number
}

const StyledLink = styled.label<LinkContainerProps>`
  a {
    color: ${({ theme, alternateLinkColor }) => (alternateLinkColor ? theme.colors.body2 : theme.colors.body)};
    margin: 0 ${({ horizontalMargin }) => (horizontalMargin ? `${horizontalMargin}rem` : '0')};
    &:hover,
    &:focus {
      text-decoration: none;
    }
  }
`

type LinkComponentProps = LinkContainerProps & LinkProps

export const Link: React.FC<LinkComponentProps> = ({ to, alternateLinkColor, horizontalMargin, ...props }) => {
  const salonGuid = getSalonGuidFromUrlParams()

  const pathWithSalonGuid = salonGuid ? `${to}?salonGuid=${salonGuid}` : to
  // eslint-disable-next-line react/jsx-props-no-spreading
  return (
    <StyledLink alternateLinkColor={alternateLinkColor} horizontalMargin={horizontalMargin}>
      <ReactRouterLink to={pathWithSalonGuid} {...props} />
    </StyledLink>
  )
}
